import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../../infrastructure/core/auth/auth.service';
import { User } from '../../models/user.model';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  isVerifiedUser = false;
  user$: Observable<User>;
  constructor(
    private authService: AuthService,
  ) {
    this.user$ = this.authService.user
      .pipe(
        map((u) => {
          const authUser = firebase.auth().currentUser;
          u.creationTime = new Date(authUser.metadata.creationTime);
          this.isVerifiedUser = u.emailVerified && u.mobileVerified;
          return u;
        })
      );
  }

  ngOnInit(): void {
  }

}
